import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Locale used to format dates/times throughout the backoffice UI.
 * `en-GB` renders DD/MM/YYYY, which matches the European convention
 * while keeping English month/day names where they appear.
 */
export const DATE_LOCALE = 'en-GB';
